module.exports = __webpack_public_path__ + "static/media/comunicacion.cb63ef56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/comunicacion.svg
// module id = 108
// module chunks = 0